<template>
  <div class="login full-fill">
    <div>
      <h2>系统登录</h2>
      <el-form ref="form" :model="form" :rules="rules" label-width="0px">
        <el-form-item prop="companyID">
          <el-select
            v-model="form.companyID"
            placeholder="账套"
            style="width: 100%"
          >
            <el-option
              v-for="item in options"
              :key="item.fid"
              :label="item.fName"
              :value="item.fid"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="userNumber">
          <el-input
            v-model="form.userNumber"
            v-focus
            placeholder="账号"
            prefix-icon="el-icon-user"
          />
        </el-form-item>
        <el-form-item prop="passWord">
          <el-input
            v-model="form.passWord"
            placeholder="密码"
            :show-password="true"
            prefix-icon="el-icon-lock"
            @keypress.enter.native="onSubmit"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :disabled="isLoading"
            @click="onSubmit"
          >登陆<span v-if="isLoading">中...</span></el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import md5 from 'md5'

function GetQueryValue(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[[]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  var results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export default {
  data: function() {
    return {
      form: {
        userNumber: '',
        passWord: '',
        companyID: ''
      },
      options: [],
      rules: {
        userNumber: [{ required: true, message: '必填项', trigger: 'change' }],
        passWord: [{ required: true, message: '必填项', trigger: 'change' }],
        companyID: [{ required: true, message: '必填项', trigger: 'change' }]
      },
      isLoading: false
    }
  },
  mounted: function() {
    this.getServerNames()
    this.$store.commit('setUserInfo', {})
  },
  methods: {
    onSubmit: function() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          const data = Object.assign({}, this.form)
          data['passWord'] = md5(
            data['userNumber'] + data['passWord'] + data['userNumber']
          ).toUpperCase()
          // data["companyID"] = await this.getServerNames();
          await this.postData(data)
        } else {
          return false
        }
      })
    },
    // 获取账套
    getServerNames: function() {
      return this.$httpPost('ServerNames', {}).then((res) => {
        this.options = res.datalist
        // return (this.form.companyID = res.datalist[0].fid);
      })
    },
    postData: function(data, extra) {
      // console.log('postData222222222222222')
      this.isLoading = true
      return this.$httpPost('login', Object.assign(data, extra))
        .then((res) => {
          if (res.isSuccess) {
            this.$store.commit('setUserNumber', this.form)
            this.$store.commit('setUserInfo', res.datalist)
            const returnUrl = GetQueryValue('returnUrl') || '/'
            this.$router.replace(returnUrl)
          } else {
            if (res.returnCode == '00006') {
              this.$confirm('是否踢出已登录帐号', '账户已在其他地方登陆', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  this.postData(data, { isKill: 'T' })
                })
                .catch(() => {
                  // console.log('用户取消选择');
                })
            } else {
              this.$alert(res.message, `错误(${res.returnCode})`, {
                confirmButtonText: '确定'
              })
            }
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2d3a4b;

  & > div {
    width: 20%;
    height: 50%;

    & > h2 {
      text-align: center;
      color: #eeeeee;
    }

    & button {
      width: 100%;
    }
  }
}
</style>
